import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { BiErrorCircle } from "react-icons/bi";
import { BsSkipEnd } from "react-icons/bs";
import { AiFillWarning } from "react-icons/ai";

export default function BatchRefundModal({ openModal, onClose }) {
  const handleCloseModal = () => {
    onClose();
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      event.stopPropagation();
    }
  };
  return (
    <>
      <Dialog
        open={openModal}
        onClose={onClose}
        fullWidth
        maxWidth="md"
        onClick={handleBackdropClick}
      >
        <DialogTitle
          sx={{ fontWeight: 700, fontSize: "20px", fontFamily: "Poppins" }}
        >
          Batch refund
          <IconButton
            aria-label="close"
            onClick={() => handleCloseModal()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#000000",
            }}
          >
            <RxCross2 />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-sm-2">
              <Typography
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                }}
              >
                Date Created
              </Typography>
            </div>
            <div className="col-sm-2">
              <Typography
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                }}
              >
                No of items
              </Typography>
            </div>
            <div className="col-sm-2">
              <Typography
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                }}
              >
                Total Amount
              </Typography>
            </div>
            <div className="col-sm-3">
              <Typography
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                }}
              >
                Total Refund Amount
              </Typography>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-2">
              <Typography
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "Poppins",
                }}
              >
                10 June 2023
              </Typography>
            </div>
            <div className="col-sm-2">
              <Typography
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "Poppins",
                }}
              >
                120
              </Typography>
            </div>
            <div className="col-sm-2">
              <Typography
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "Poppins",
                }}
              >
                $1200
              </Typography>
            </div>
            <div className="col-sm-2">
              <Typography
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: "Poppins",
                }}
              >
                $100
              </Typography>
            </div>
          </div>

          <div className="row align-items-center pt-3">
            <Typography
              sx={{ fontSize: "18px", fontWeight: 500, fontFamily: "Poppins" }}
            >
              Error Found
            </Typography>
            <BiErrorCircle
              style={{
                height: "24px",
                width: "24px",
                color: "rgba(158, 87, 7, 1)",
              }}
            />
          </div>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              fontFamily: "Poppins",
              color: "rgba(1, 1, 2, 0.6)",
            }}
            className="pt-1"
          >
            4 Items
          </Typography>
          <Paper
            style={{
              //   width: "986px",
              height: "340px",
              overflow: "scroll",
              overflowX: "hidden",
              borderRadius: "16px",
              backgroundColor: "rgba(244, 244, 244, 1)",
              marginTop: "8px",
              padding: "10px 0 0 15px",
            }}
          >
            <div className="pt-2">
              <div className="row">
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Order ID
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Transaction ID{" "}
                  </Typography>
                </div>
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Original Amount
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Refund Amount
                  </Typography>
                </div>
                <div className="col-sm-1" />
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="Order ID"
                  />
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(185, 35, 47, 1)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="bdD2FU8YRq"
                  />
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "rgba(185, 35, 47, 1)",
                    }}
                  >
                    Transaction ID not found
                  </p>
                </div>
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="$100"
                  />
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="ME11011"
                  />
                </div>
                <div className="col-sm-1 pt-2">
                  <AiFillWarning
                    style={{
                      height: "32px",
                      width: "32px",
                      color: "rgba(158, 87, 7, 1)",
                    }}
                  />
                </div>
              </div>
            </div>
            <Divider style={{ padding: "10px 0", marginRight: "15px" }} />
            <div className="pt-2">
              <div className="row">
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Order ID
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Transaction ID{" "}
                  </Typography>
                </div>
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Original Amount
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Refund Amount
                  </Typography>
                </div>
                <div className="col-sm-1" />
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="Order ID"
                  />
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="bdD2FU8YRq"
                  />
                </div>
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="$100"
                  />
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(185, 35, 47, 1)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="ME11011"
                  />
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "rgba(185, 35, 47, 1)",
                    }}
                  >
                    Amount exceeds original
                  </p>
                </div>
                <div className="col-sm-1 pt-2">
                  <AiFillWarning
                    style={{
                      height: "32px",
                      width: "32px",
                      color: "rgba(158, 87, 7, 1)",
                    }}
                  />
                </div>
              </div>
            </div>
            <Divider style={{ padding: "10px 0", marginRight: "15px" }} />
            <div className="pt-2">
              <div className="row">
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Order ID
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Transaction ID{" "}
                  </Typography>
                </div>
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Original Amount
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Refund Amount
                  </Typography>
                </div>
                <div className="col-sm-1" />
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="Order ID"
                  />
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="bdD2FU8YRq"
                  />
                </div>
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="$100"
                  />
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(185, 35, 47, 1)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="ME11011"
                  />
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "rgba(185, 35, 47, 1)",
                    }}
                  >
                    Amount exceeds original
                  </p>
                </div>
                <div className="col-sm-1 pt-2">
                  <AiFillWarning
                    style={{
                      height: "32px",
                      width: "32px",
                      color: "rgba(158, 87, 7, 1)",
                    }}
                  />
                </div>
              </div>
            </div>
            <Divider style={{ padding: "10px 0", marginRight: "15px" }} />
            <div className="pt-2">
              <div className="row">
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Order ID
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Transaction ID{" "}
                  </Typography>
                </div>
                <div className="col-sm-2">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Original Amount
                  </Typography>
                </div>
                <div className="col-sm-3">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    Refund Amount
                  </Typography>
                </div>
                <div className="col-sm-1" />
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(185, 35, 47, 1)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="Order ID"
                  />
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "rgba(185, 35, 47, 1)",
                    }}
                  >
                    Order Id is not valid
                  </p>
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="bdD2FU8YRq"
                  />
                </div>
                <div className="col-sm-2">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="$100"
                  />
                </div>
                <div className="col-sm-3">
                  <TextField
                    id="outlined-basic"
                    sx={{
                      backgroundColor: "white",
                      border: "1px solid rgba(1, 1, 2, 0.45)",
                      borderRadius: "6px",
                      marginTop: "5px",
                    }}
                    size="small"
                    variant="outlined"
                    placeholder="ME11011"
                  />
                </div>
                <div className="col-sm-1 pt-2">
                  <AiFillWarning
                    style={{
                      height: "32px",
                      width: "32px",
                      color: "rgba(158, 87, 7, 1)",
                    }}
                  />
                </div>
              </div>
            </div>
            <Divider style={{ padding: "10px 0", marginRight: "15px" }} />
          </Paper>
        </DialogContent>
        <DialogActions style={{ paddingBottom: "15px" }}>
          <Button
            variant="outlined"
            style={{
              color: "rgba(36, 183, 170, 1)",
              marginRight: "10px",
              textTransform: "none",
              fontSize: "20px",
              width: "210px",
              height: "48px",
              fontWeight: 600,
              borderRadius: "8px",
              border: "2px solid",
              fontFamily: "Poppins",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              fontWeight: 600,
              backgroundColor: "#24B7AA",
              borderRadius: "8px",
              textTransform: "none",
              marginRight: "10px",
              width: "236px",
              fontSize: "18px",
              width: "210px",
              height: "48px",
              fontFamily: "Poppins",
            }}
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
